import React, { useState, useEffect } from 'react';
import './inspectionprojects.css';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import BusinessIcon from '@mui/icons-material/Business';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhoneIcon from '@mui/icons-material/Phone';
import { getProjectsData } from '../../data/projectsDataLoader';
import { projectsData as localProjectsData } from '../../data/projectsData';
import Callbackpopup from '../callbackpopup/Callbackpopup';
import { dialBusinessPhoneWithAdsConversion } from '../../utils/analytics';

const INITIAL_PROJECT_COUNT = 6;

const Inspectionprojects = () => {
  const [projectsData, setProjectsData] = useState(localProjectsData);
  const [isLoading, setIsLoading] = useState(true);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [showAllProjects, setShowAllProjects] = useState(false);

  useEffect(() => {
    const loadProjectsData = async () => {
      try {
        const data = await getProjectsData();
        setProjectsData(data);
      } catch (error) {
        console.error('Error loading projects data:', error);
        // Keep local fallback
        setProjectsData(localProjectsData);
      } finally {
        setIsLoading(false);
      }
    };
    loadProjectsData();
  }, []);

  const { header, projects, cta } = projectsData;
  const visibleProjects = showAllProjects
    ? projects
    : (projects || []).slice(0, INITIAL_PROJECT_COUNT);
  const remainingCount = Math.max((projects || []).length - INITIAL_PROJECT_COUNT, 0);

  const handleToggleProjects = () => {
    setShowAllProjects((current) => !current);
  };

  const handleQuickConsultation = () => {
    // Check if device is mobile
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    if (isMobile) {
      dialBusinessPhoneWithAdsConversion();
    } else {
      // Open popup on desktop
      setPopupOpen(true);
      document.body.style.overflow = 'hidden';
    }
  };

  const closePopup = () => {
    setPopupOpen(false);
    document.body.style.overflow = 'auto';
  };

  // Show loading state or fallback to local data
  if (isLoading && !projectsData) {
    return (
      <div className="projects-section" id="projects">
        <div className="projects-container">
          <div className="projects-header">
            <p>Loading projects...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="projects-section" id="projects">
      <div className="projects-container">
        {/* Header Section */}
        <div className="projects-header">
          <div className="projects-badge">
            <BusinessIcon className="badge-icon" />
            <span>{header.badge.text}</span>
          </div>
          <h1 className="projects-title">{header.title}</h1>
          <p className="projects-description">
            {header.description}
          </p>
        </div>

        {/* Projects Grid — only the first 6 cards (and their images) render until expanded */}
        <div className="projects-grid">
          {visibleProjects.map((project, index) => (
            <div key={`${project.projectName}-${project.location}-${index}`} className="project-card">
              <div className="project-image-container">
                <img
                  src={project.image}
                  alt={`${project.projectName} - ${project.location}`}
                  className="project-image"
                  loading="lazy"
                  decoding="async"
                  width="600"
                  height="600"
                />
                <div className="project-overlay">
                  <div className="project-status">
                    <CheckCircleIcon className="status-icon" />
                    <span>{project.status}</span>
                  </div>
                </div>
              </div>
              
              <div className="project-content">
                <div className="project-header">
                  <h3 className="project-name">{project.projectName}</h3>
                  <div className="project-category">{project.category}</div>
                </div>
                
                <div className="project-location">
                  <LocationOnIcon className="location-icon" />
                  <span>{project.location}</span>
                </div>
                
              </div>
            </div>
          ))}
        </div>

        {remainingCount > 0 && (
          <div className="projects-more">
            <p
              onClick={handleToggleProjects}
              className="projects-more-link"
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  handleToggleProjects();
                }
              }}
            >
              {showAllProjects
                ? 'Show less'
                : `And ${remainingCount} more projects`}
            </p>
          </div>
        )}


        {/* Call to Action */}
        <div className="projects-cta">
          <div className="cta-content">
            <div className="cta-badge">
              <CheckCircleIcon className="badge-icon" />
              <span>{cta.badge.text}</span>
            </div>
            <h3 className="cta-title">{cta.title}</h3>
            <p className="cta-description">
              {cta.description}
            </p>
            {/* <div className="cta-stats">
              {cta.stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <span className="stat-number">{stat.number}</span>
                  <span className="stat-label">{stat.label}</span>
                </div>
              ))}
            </div> */}
            <button className="cta-button" onClick={handleQuickConsultation}>
              <span>{cta.button.text}</span>
              <PhoneIcon className="button-icon" />
            </button>
          </div>
        </div>
      </div>
      
      {/* Callback Popup */}
      {isPopupOpen && <Callbackpopup onClose={closePopup} cardItem="Free Consultation" />}
    </div>
  );
};

export default Inspectionprojects;